import type { ProductParameter } from './productTypes';

export const fixedParameterNames = ['尺寸', '克重', '工艺', '手柄材质', '气囊材质', '梳齿材质'] as const;
export const maxProductParameters = 20;

// Match one existing value to each fixed row. Keep all remaining legacy rows,
// including duplicate names, so opening and saving never silently loses data.
export function parameterDraft(parameters: ProductParameter[]): ProductParameter[] {
  const remaining = parameters.map(parameter => ({ ...parameter }));
  const fixed = fixedParameterNames.map(name => {
    const index = remaining.findIndex(parameter => parameter.name.trim() === name);
    return { name, value: index < 0 ? '' : remaining.splice(index, 1)[0].value };
  });
  return [...fixed, ...remaining];
}

export function parametersToSave(parameters: ProductParameter[]): ProductParameter[] {
  // Only populated fixed values are stored. Custom rows still need both fields.
  return parameters.filter((parameter, index) => index >= fixedParameterNames.length || parameter.value.trim())
    .map(parameter => ({ name: parameter.name.trim(), value: parameter.value.trim() }));
}
